import React from 'react'
import { TaskSource, SOURCE_CONFIG } from '../types/operations.types'
import { Badge } from '../styled/Operations.styled'

interface SourceBadgeProps {
  source: TaskSource
}

export const SourceBadge: React.FC<SourceBadgeProps> = ({ source }) => {
  const config = SOURCE_CONFIG[source]
  return (
    <Badge bg={config.color}>
      {config.label}
    </Badge>
  )
}
